import React, { Component } from 'react';

class Body extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isNavOpen: this.props.navStatus
        };
    }
    componentWillReceiveProps(nextProps) {
		this.setState({ isNavOpen: nextProps.navStatus });
	}
    render() {
        return (
            <div className={`body ${this.state.isNavOpen === true ? 'bodyMove' : ''}`}>
                {this.props.children}
            </div>
        )
    }
}

export default Body;


// WEBPACK FOOTER //
// ./src/redux/components/molecules/Body/Body.js